interface SemanticType {
	category: string
	categoryDescription: string
	description: string
	typeId: string
}
export const semanticTypes = new Map<string, SemanticType>();

`ACTI|Activities & Behaviors|T052|Activity
ACTI|Activities & Behaviors|T053|Behavior
ACTI|Activities & Behaviors|T056|Daily or Recreational Activity
ACTI|Activities & Behaviors|T051|Event
ACTI|Activities & Behaviors|T064|Governmental or Regulatory Activity
ACTI|Activities & Behaviors|T055|Individual Behavior
ACTI|Activities & Behaviors|T066|Machine Activity
ACTI|Activities & Behaviors|T057|Occupational Activity
ACTI|Activities & Behaviors|T054|Social Behavior
ANAT|Anatomy|T017|Anatomical Structure
ANAT|Anatomy|T029|Body Location or Region
ANAT|Anatomy|T023|Body Part, Organ, or Organ Component
ANAT|Anatomy|T030|Body Space or Junction
ANAT|Anatomy|T031|Body Substance
ANAT|Anatomy|T022|Body System
ANAT|Anatomy|T025|Cell
ANAT|Anatomy|T026|Cell Component
ANAT|Anatomy|T018|Embryonic Structure
ANAT|Anatomy|T021|Fully Formed Anatomical Structure
ANAT|Anatomy|T024|Tissue
CHEM|Chemicals & Drugs|T116|Amino Acid, Peptide, or Protein
CHEM|Chemicals & Drugs|T195|Antibiotic
CHEM|Chemicals & Drugs|T123|Biologically Active Substance
CHEM|Chemicals & Drugs|T122|Biomedical or Dental Material
CHEM|Chemicals & Drugs|T103|Chemical
CHEM|Chemicals & Drugs|T120|Chemical Viewed Functionally
CHEM|Chemicals & Drugs|T104|Chemical Viewed Structurally
CHEM|Chemicals & Drugs|T200|Clinical Drug
CHEM|Chemicals & Drugs|T196|Element, Ion, or Isotope
CHEM|Chemicals & Drugs|T126|Enzyme
CHEM|Chemicals & Drugs|T131|Hazardous or Poisonous Substance
CHEM|Chemicals & Drugs|T125|Hormone
CHEM|Chemicals & Drugs|T129|Immunologic Factor
CHEM|Chemicals & Drugs|T130|Indicator, Reagent, or Diagnostic Aid
CHEM|Chemicals & Drugs|T197|Inorganic Chemical
CHEM|Chemicals & Drugs|T114|Nucleic Acid, Nucleoside, or Nucleotide
CHEM|Chemicals & Drugs|T109|Organic Chemical
CHEM|Chemicals & Drugs|T121|Pharmacologic Substance
CHEM|Chemicals & Drugs|T192|Receptor
CHEM|Chemicals & Drugs|T127|Vitamin
CONC|Concepts & Ideas|T185|Classification
CONC|Concepts & Ideas|T077|Conceptual Entity
CONC|Concepts & Ideas|T169|Functional Concept
CONC|Concepts & Ideas|T102|Group Attribute
CONC|Concepts & Ideas|T078|Idea or Concept
CONC|Concepts & Ideas|T170|Intellectual Product
CONC|Concepts & Ideas|T171|Language
CONC|Concepts & Ideas|T080|Qualitative Concept
CONC|Concepts & Ideas|T081|Quantitative Concept
CONC|Concepts & Ideas|T089|Regulation or Law
CONC|Concepts & Ideas|T082|Spatial Concept
CONC|Concepts & Ideas|T079|Temporal Concept
DEVI|Devices|T203|Drug Delivery Device
DEVI|Devices|T074|Medical Device
DEVI|Devices|T075|Research Device
DISO|Disorders|T020|Acquired Abnormality
DISO|Disorders|T190|Anatomical Abnormality
DISO|Disorders|T049|Cell or Molecular Dysfunction
DISO|Disorders|T019|Congenital Abnormality
DISO|Disorders|T047|Disease or Syndrome
DISO|Disorders|T050|Experimental Model of Disease
DISO|Disorders|T033|Finding
DISO|Disorders|T037|Injury or Poisoning
DISO|Disorders|T048|Mental or Behavioral Dysfunction
DISO|Disorders|T191|Neoplastic Process
DISO|Disorders|T046|Pathologic Function
DISO|Disorders|T184|Sign or Symptom
GENE|Genes & Molecular Sequences|T087|Amino Acid Sequence
GENE|Genes & Molecular Sequences|T088|Carbohydrate Sequence
GENE|Genes & Molecular Sequences|T028|Gene or Genome
GENE|Genes & Molecular Sequences|T085|Molecular Sequence
GENE|Genes & Molecular Sequences|T086|Nucleotide Sequence
GEOG|Geographic Areas|T083|Geographic Area
LIVB|Living Beings|T100|Age Group
LIVB|Living Beings|T011|Amphibian
LIVB|Living Beings|T008|Animal
LIVB|Living Beings|T194|Archaeon
LIVB|Living Beings|T007|Bacterium
LIVB|Living Beings|T012|Bird
LIVB|Living Beings|T204|Eukaryote
LIVB|Living Beings|T099|Family Group
LIVB|Living Beings|T013|Fish
LIVB|Living Beings|T004|Fungus
LIVB|Living Beings|T096|Group
LIVB|Living Beings|T016|Human
LIVB|Living Beings|T015|Mammal
LIVB|Living Beings|T001|Organism
LIVB|Living Beings|T101|Patient or Disabled Group
LIVB|Living Beings|T002|Plant
LIVB|Living Beings|T098|Population Group
LIVB|Living Beings|T097|Professional or Occupational Group
LIVB|Living Beings|T014|Reptile
LIVB|Living Beings|T010|Vertebrate
LIVB|Living Beings|T005|Virus
OBJC|Objects|T071|Entity
OBJC|Objects|T168|Food
OBJC|Objects|T073|Manufactured Object
OBJC|Objects|T072|Physical Object
OBJC|Objects|T167|Substance
OCCU|Occupations|T091|Biomedical Occupation or Discipline
OCCU|Occupations|T090|Occupation or Discipline
ORGA|Organizations|T093|Health Care Related Organization
ORGA|Organizations|T092|Organization
ORGA|Organizations|T094|Professional Society
ORGA|Organizations|T095|Self-help or Relief Organization
PHEN|Phenomena|T038|Biologic Function
PHEN|Phenomena|T069|Environmental Effect of Humans
PHEN|Phenomena|T068|Human-caused Phenomenon or Process
PHEN|Phenomena|T034|Laboratory or Test Result
PHEN|Phenomena|T070|Natural Phenomenon or Process
PHEN|Phenomena|T067|Phenomenon or Process
PHYS|Physiology|T043|Cell Function
PHYS|Physiology|T201|Clinical Attribute
PHYS|Physiology|T045|Genetic Function
PHYS|Physiology|T041|Mental Process
PHYS|Physiology|T044|Molecular Function
PHYS|Physiology|T032|Organism Attribute
PHYS|Physiology|T040|Organism Function
PHYS|Physiology|T042|Organ or Tissue Function
PHYS|Physiology|T039|Physiologic Function
PROC|Procedures|T060|Diagnostic Procedure
PROC|Procedures|T065|Educational Activity
PROC|Procedures|T058|Health Care Activity
PROC|Procedures|T059|Laboratory Procedure
PROC|Procedures|T063|Molecular Biology Research Technique
PROC|Procedures|T062|Research Activity
PROC|Procedures|T061|Therapeutic or Preventive Procedure`.split('\n').forEach(row => {
	let [ category, categoryDescription, typeId, description ] = row.split('|')
	semanticTypes.set(typeId, { category, categoryDescription, typeId, description })
})

const tuiInterventionPropensity = {
	T031: 0.4, // Body substance (plasma can be an intervention)
	T121: 1, // Pharmacologic Substance
	T052: 0.5, // Activity (like hand washing)
	T060: 0.75, // diagnostic procedure
	T061: 1,
	T064: 0.3,
	T065: 0.9,
	T073: 0.8,
	T074: 0.95, // medical device
	T116: 0.4,
	T195: 1,
	T123: 0.4,
	T122: 0.8,
	T200: 1,
	T126: 0.3,
	T125: 0.4,
	T127: 0.8,
}
const tuiOutcomePropensity = {
	T005: 0.3, // Virus
	T201: 0.8, // Clinical Attribute
	T184: 0.6,
	T034: 0.8,
	T033: 0.8, //Finding
	T191: 0.3,
	T046: 0.5, // Pathological Function
	T047: 0.3, // Disease or syndrome
	T081: 0.6, // Quantitative concept. Good for outcomes
	T170: 0.5, // Intellectual Product, which is often used for outcomes, particularly for questionnaire/scores
	T070: 0.3,
	T067: 0.3,
	T058: 0.22, // Health care activity
}
const tuiCharacteristicPropensity = {
	T005: 0.6, // Virus
	T047: 1, // Disease or syndrome
	T191: 0.6, // Neoplastic Process
	T087: 1,
	T088: 1,
	T028: 1,
	T085: 1,
	T086: 1,
	T184: 0.6,
	T190: 1,
	T049: 1,
	T019: 1,
	T050: 1,
	T033: 0.7,
	T037: 1,
	T048: 1,
	T046: 0.4,
	T098: 1, // Population Group
	T015: 1, // Mammal
}
const addPropensities = (propensities, type) => {
	for (let semanticType in propensities) {
		semanticTypes.get(semanticType)[type] = propensities[semanticType]
	}
}
addPropensities(tuiInterventionPropensity, 'intervention')
addPropensities(tuiOutcomePropensity, 'outcome')
addPropensities(tuiCharacteristicPropensity, 'characteristic')

export function inferPICO(types: string[]): 'int' | 'out' | 'char' {
	let bestScore = 0
	let suggestedType
	for (let semanticType of types || []) {
		let definition = semanticTypes.get(semanticType)
		if (definition) {
			if (definition.outcome > bestScore) {
				bestScore = definition.outcome
				suggestedType = 'out'
			}
			if (definition.intervention > bestScore) {
				bestScore = definition.intervention
				suggestedType = 'int'
			}
			if (definition.characteristic > bestScore) {
				bestScore = definition.characteristic
				suggestedType = 'char'
			}
		}
	}
	return suggestedType
}
